import { useContext } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { UserContext } from "../contexts/userProvider";
import { ClientProvider } from "../contexts/clientProvider";
import { SecretariasProvider } from "../contexts/secretariasProvider";
import { DashProvider } from "../contexts/dashProvider";
import { AnexosProvider } from "../contexts/anexosProvider";
import { FornecedoresProvider } from "../contexts/fornecedoresProvider";
import { PatrimonioProvider } from "../contexts/patrimonioProvider";
import { RelatoriosProvider } from "../contexts/relatoriosProvider";
import { VoxSoftwaresProvider } from "../contexts/voxSoftwaresProvider";
import { FaturadorProvider } from "../contexts/faturadorProvider";
import { EquipamentosProvider } from "../contexts/equipamentosProvider";
import { ItensProvider } from "../contexts/ItensProvider";
import { ContratosProvider } from "../contexts/ContratosProvider";
import { UsuariosProvider } from "../contexts/usuariosProvider";
import LoadingSpinner from "../components/Loader/load";

export default function Authenticator({ children }) {
    const { signed, validando } = useContext(UserContext);
    let location = useLocation();
    const isNotAuth = location.pathname === "/openTable" || location.pathname.includes("senha") || location.pathname === "/termos";

    return (
        <>
            {signed === true ? (
                <>
                    <DashProvider>
                        <ClientProvider>
                            <SecretariasProvider>
                                <AnexosProvider>
                                <FornecedoresProvider>
                                    <PatrimonioProvider>
                                        <ItensProvider>
                                            <ContratosProvider>
                                                <RelatoriosProvider>
                                                    <VoxSoftwaresProvider>
                                                        <FaturadorProvider>
                                                            <EquipamentosProvider>
                                                                <UsuariosProvider>
                                                                    {children}
                                                                </UsuariosProvider>
                                                            </EquipamentosProvider>
                                                        </FaturadorProvider>
                                                    </VoxSoftwaresProvider>
                                                </RelatoriosProvider>
                                            </ContratosProvider>
                                        </ItensProvider>
                                    </PatrimonioProvider>
                                </FornecedoresProvider>
                                </AnexosProvider>
                            </SecretariasProvider>
                        </ClientProvider>
                    </DashProvider>
                </>
            )
                : validando ? (
                    // Sessao persistida sendo validada (refresh): espera antes de decidir.
                    <div className="h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                        <LoadingSpinner />
                    </div>
                )
                : isNotAuth ? (
                    <>
                        {children}
                    </>
                )
                    :
                    (
                        <>
                            <Navigate to="/login" replace state={{ path: location.pathname }} />
                        </>
                    )}
        </>
    );
}
